import { IAugmentedJQuery, IDocumentService, IRootScopeService, IWindowService } from 'angular';
import { PopoverController, PopoverService } from '../../tn.popover/service.tn.popover';
import { UserService } from '../../tn.user/service.tn.user';
import { IFontStyleModel } from '../../tn.common';
import { IFavoriteList } from '../favorites-repository.service/favoritesRepository';
import { LocalFavorites } from '../local-favorites.service/localFavorites';
import template from './save-favorite-popover.html';

export type SaveFavoriteControllerState = 'login' | 'add' | 'success';

export class SaveFavoritePopoverController extends PopoverController {
    selectedStyles: IFontStyleModel[] = [];
    currentState: SaveFavoriteControllerState = this.userService.isLoggedIn() ? 'add' : 'login';
    createdList?: IFavoriteList;
    alignment: 'left' | 'right' | 'top' | 'bottom' = 'bottom';

    static $inject = [
        '$window',
        '$document',
        '$element',
        'localFavorites',
        'tn.user.service',
        '$tnPopover',
        '$rootScope',
    ];
    constructor(
        protected $window: IWindowService,
        protected $document: IDocumentService,
        protected $element: IAugmentedJQuery,
        protected localFavorites: LocalFavorites,
        protected userService: UserService,
        protected $tnPopover: PopoverService,
        protected $rootScope: IRootScopeService
    ) {
        // the Popover controller expects the first child of the element
        // of the legacy popover structure. TODO: fix it.
        super($window, $document, $element.children().first());
        // add self to popover service for global hides.
        $tnPopover.popovers.push(this);

        userService.login$.subscribe(() => {
            this.currentState = 'add';
        });
        userService.logout$.subscribe(() => {
            this.currentState = 'login';
            this.createdList = undefined;
        });
    }

    show(anchor?: Element | EventTarget | null): void {
        // since we share a single dialog for all buttons we need to reset
        // the state when the popover is shown.
        this.currentState = this.userService.isLoggedIn() ? 'add' : 'login';
        super.show(anchor);
    }

    onLogin(): void {
        this.currentState = 'add';
    }

    onAdded(list: IFavoriteList): void {
        this.createdList = list;
        this.currentState = 'success';
    }
}


export const SaveFavoritePopoverComponent = {
    controller: SaveFavoritePopoverController,
    template,
    bindings: {
        selectedStyles: '<',
    },
};